import { ConfigService } from './config.service';
export * from './config.service';

export const SERVICES = [
  ConfigService
];
